import ImgSized from "./ImgSized";

export default ImgSized;
